// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver, mapReviver } = require('client-v2/common/state/revivers')
// Container imports
const TooltipItemRecord = require('./records/item')

class TooltipsRecord extends Immutable.Record({
  itemsByKey: Immutable.Map()
}) {
  getItem(key) {
    return this.itemsByKey.get(key)
  }

  addItem(item) {
    return this.setIn(['itemsByKey', item.key], item)
  }

  dismissItem(key) {
    return this.setIn(['itemsByKey', key, 'isDismissed'], true)
  }

  removeItem(key) {
    return this.removeIn(['itemsByKey', key])
  }
}

TooltipsRecord.reviver = keyedReviver(TooltipsRecord, {
  itemsByKey: mapReviver(TooltipItemRecord.reviver)
})

module.exports = TooltipsRecord
